import './App.css';
import React, { useEffect, useState } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import routes, { renderRoutes } from './../src/routes';
import axios from 'axios';
import Loading from './Layouts/Loding';

function App() {
  const history = useHistory();
  const path = useLocation().pathname;
  /* const [loading, setLoading] = useState("none");

  axios.interceptors.request.use(function(config) {
    setLoading("flex");
    console.log(config)
    return config;
  }, function(error) {
    return Promise.reject(error);
  });
  axios.interceptors.response.use(function(response) {
    setLoading("none");
    return response;
  }, function(error) {
    return Promise.reject(error);
  }); */

  console.log(process.env.REACT_APP_URL)

  useEffect(()=>{
    const token = localStorage.getItem("token");

    if(token && (path === "/auth/login" || path === "/")) history.push("/program/insert");
    if(path !== "/auth/login"){
      if(!token) history.push("/auth/login")
      else{
        axios({
          method: "POST",
          url: `${process.env.REACT_APP_URL}/check-login`,
          headers: {"Content-Type": "application/json"},
          data: JSON.stringify({token})
        }).then(res=>{
          if(res.data.status !== "success"){
            localStorage.removeItem("token");
            history.push("/auth/login")
          }
        }).catch(e=>{
          /* localStorage.removeItem("token");
          history.push("/auth/login") */
        })
      }
    }
  }, [path])

  return (
    <>
      {/* <Loading open={loading}></Loading> */}
      {renderRoutes(routes)}
    </>
  );
}

export default App;
